/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Dashboard Title Component
 */

// Dependencies
import PropTypes from 'prop-types';

const DashboardTitle = ({
  title,
  description,
  children,
  descriptionProgress,
  isTitleBold = true
}) => {
  const marginTop = descriptionProgress && description ? 'mt-8' : 'mt-0';
  return (
    <div className="w-full text-left text-baxterGray">
      <div className="flex flex-wrap w-full">
        {isTitleBold ? (
          <h1 className={`font-bold ${children ? 'w-3/5' : ''}`}>{title}</h1>
        ) : (
          <p className={` ${children ? 'w-3/5' : ''}`}>{title}</p>
        )}
        <div
          className="w-2/5 float-right flex flex-wrap justify-end"
          style={{ alignItems: 'baseline' }}>
          {children}
        </div>
      </div>
      <p
        className={`mb-0 ${marginTop}`}
        style={{
          fontSize: '12px'
        }}>
        {description}
      </p>
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardTitle.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.element,
  descriptionProgress: PropTypes.bool,
  isTitleBold: PropTypes.bool
};

export default DashboardTitle;
